import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { InitialFoldedReport } from './InitialFoldedReport';
import { Chapter } from './Chapter';

interface MainProps {
  data: any;
  mainRef: any;
  chapterRefs: Array<any>;
}

export const Main: FC<MainProps> = ({ data, mainRef, chapterRefs }) => {
  const { edges } = data.chapters;
  const chapters = edges;
  const toggleChapterInitialState = new Array(chapters.length).fill(false);
  const [openChapter, setOpenChapter] = useState(0);
  const [open, setOpen] = useState(toggleChapterInitialState);

  return (
    <StyledMain ref={mainRef}>
      <InitialFoldedReport data={data.data} />

      {chapters.map((chapter: any, i: number) => {
        return (
          <Chapter
            chapterRef={chapterRefs[i]}
            chapter={chapter.node}
            chapterNumber={i + 1}
            key={i + 1}
            setOpenChapter={setOpenChapter}
            openChapter={openChapter === i + 1}
            open={open}
            setOpen={setOpen}
          />
        );
      })}
    </StyledMain>
  );
};

const StyledMain = styled.div`
  width: 100%;
  height: 100%;
`;
